import { TEvent } from '@/_types/event.type';
import { TConferenceProgram } from '@/_modules/promo/types/conference-program.type';
import { ConferenceProgramChatType } from '@/_modules/promo-program/types/conference-program-chat-type.enum';
// import { TChatGroup } from '@/_modules/chat/types/chat-group.type';
// import { TConferenceProgram } from '@/_modules/promo/types/conference-program.type';
// import { ConferenceProgramChatType } from '@/_modules/promo-program/types/conference-program-chat-type.enum';

export default class ChatHelper {

  public static getEventChatGroupId(event: TEvent): string {
    if (!event || !event.id) {
      return null;
    }
    return 'main';
  }

  public static getProgramChatGroupId(program: TConferenceProgram, chatType: ConferenceProgramChatType): string {
    if (!program || !program.id) {
      return null;
    }
    // TODO: prepend 'event_[eventId]_' ?
    return `program_${program.id}_${chatType}`;
  }

  public static createLink(text: string): string {
    const urlRegex = /(https?:\/\/[^\s]+)/g;
    if(text) {
      return text.replace(urlRegex, function(url: string) {
        if ( ( url.indexOf('.jpg') > 0 && url.indexOf('.jpg') === url.length - 4 ) || ( url.indexOf('.png') > 0 && url.indexOf('.jpg') === url.length - 4 ) || ( url.indexOf('.gif') > 0 && url.indexOf('.jpg') === url.length - 4 ) ) {
          return '<a target="_blank" class="link chat-image" href="' + url + '">' + '<img width="100px" src="' + url + '"/>' + '</a>';
        } else {
          return '<a target="_blank" class="link" href="' + url + '">' + url + '</a>' + '<br/>';
        }
      });
    }
    return '';
  }

  public static createLinkOnly(text: string): string {
    const urlRegex = /(https?:\/\/[^\s]+)/g;
    if(text) {
      return text.replace(urlRegex, function(url: string) {
        return '<a target="_blank" class="link" href="' + url + '">' + url + '</a>' + '<br/>';
      });
    }
    return '';
  }

  // TODO: review -------------------------------------------------

  // public static getEventChatGroup(event: TEvent): TChatGroup {
  //   if (!event || !event.id) {
  //     return null;
  //   }
  //   const groupId = ChatHelper.getEventChatGroupId(event);
  //   if (!groupId) {
  //     return null;
  //   }
  //   return {
  //     id: groupId,
  //     name: event.title || '',
  //   };
  // }
  //
  // public static getProgramChatGroup(program: TConferenceProgram, chatType: ConferenceProgramChatType): TChatGroup {
  //   if (!program || !program.id) {
  //     return null;
  //   }
  //   const groupId = ChatHelper.getProgramGroupId(program, chatType);
  //   if (!groupId) {
  //     return null;
  //   }
  //   return {
  //     id: groupId,
  //     name: program.title || '',
  //   };
  // }
  //
  // public static getUserId(config: TChatConfig): string {
  //   if (!config || !config.event || !config.contact) {
  //     return null;
  //   }
  //   return `event_${config.event.id}_contact_${config.contact.id}`;
  // }
  //
  // public static getProgramGroupId(program: TConferenceProgram, chatType: ConferenceProgramChatType): string {
  //   if (!program || !program.id) {
  //     return null;
  //   }
  //   // TODO: prepend 'event_[eventId]_'
  //   return `program_${program.id}_${chatType}`;
  // }

}
